module.exports = __webpack_public_path__ + "img/sieckFinesseSetup8.11090934.png";